// extracted by mini-css-extract-plugin
export default {"image":"styles_image__X7FUG","title":"styles_title__dgLwl"};